import styles from './Select.module.scss'

import { Spinner } from '@/components/Spinner'
import { c } from '@/utils'

export interface SelectOption {
  value: string
  label: string
  title?: string
  isDisabled?: boolean
}

interface SelectProps {
  value: string
  options: SelectOption[]
  onChange: (value: string) => void
  isDisabled?: boolean
  isLoading?: boolean
  className?: string
  placeholder?: string
  id?: string
  title?: string
  ariaLabel?: string
}

const Select = ({
  value,
  options,
  onChange,
  isDisabled,
  isLoading,
  className,
  placeholder,
  id,
  title,
  ariaLabel,
}: SelectProps) => {
  return (
    <div className={styles.container}>
      {isLoading && (
        <div className={styles.spinnerOverlay}>
          <Spinner size={14} color="black" />
        </div>
      )}
      <select
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={isDisabled || isLoading}
        title={title}
        aria-label={ariaLabel}
        className={c(styles.select, className)}
      >
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {options.map((option) => (
          <option key={option.value} value={option.value} title={option.title} disabled={option.isDisabled}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  )
}

export default Select
